export default __webpack_public_path__ + "static/media/physical-therapy.aa5eef47.png";